import { useEffect, useRef } from 'react';
import window from 'global/window';
import _ from 'lodash';
import { formatName } from 'shared/helpers/users';
import useStores from './use-stores';
import { hideZendeskWidget, showDecagonWidget, closeZendeskWidget } from '../helpers/tools';
export default function useConsumerChatWidget() {
  var _useStores = useStores(),
    UI = _useStores.UI,
    User = _useStores.User,
    Cart = _useStores.Cart;
  var metadataSetRef = useRef(false);
  useEffect(function () {
    closeZendeskWidget();
    hideZendeskWidget();
    return initializeDecagon(UI);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    // Poll for window.duet to become available, then set metadata once
    var interval = setInterval(function () {
      if (window.duet && !metadataSetRef.current) {
        metadataSetRef.current = true;
        if (User.exists) {
          window.duet.setUserId(User.id);
          window.duet.setMetadata({
            email: User.email,
            name: User.fullName,
            phone: User.phone
          });
        } else if (Cart.guestCustomer) {
          window.duet.setMetadata({
            phone: Cart.guestCustomer.phone,
            name: formatName(Cart.guestCustomer)
          });
        }
        clearInterval(interval);
      }
    }, 100);
    return function () {
      return clearInterval(interval);
    };
    // Don't update mid-conversation or else Decagon clears the chat history and confuses the end user
    // Only set metadata once when window.duet becomes available
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
function initializeDecagon(UI) {
  // Skip Decagon in E2E test environments - the widget's high z-index (99999999)
  // interferes with MUI modals during Playwright tests
  if (typeof window !== 'undefined' && window.__PLAYWRIGHT_TEST__) {
    return _.noop;
  }
  if (UI.isVariant("default") && !window.duet) {
    var decagonInitScript = document.createElement("script");
    decagonInitScript.id = "chat-loader";
    decagonInitScript.src = "https://decagon.ai/loaders/dutchie.js";
    decagonInitScript.async = true;
    document.body.appendChild(decagonInitScript);
  }

  // make sure it's not hidden from before
  showDecagonWidget();
  return function () {
    var _window$duet;
    return (_window$duet = window.duet) === null || _window$duet === void 0 ? void 0 : _window$duet.hide();
  };
}